import { render, staticRenderFns } from "./BaseScrollbar.vue?vue&type=template&id=7a2f8f6c&scoped=true&"
import script from "./BaseScrollbar.vue?vue&type=script&lang=js&"
export * from "./BaseScrollbar.vue?vue&type=script&lang=js&"
import style0 from "./BaseScrollbar.vue?vue&type=style&index=0&id=7a2f8f6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a2f8f6c",
  null
  
)

export default component.exports